import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { VolunteerCoordinator, Spiritual, SocialWorker, Nurse, Doctor } from '@mummssoftware/utils/roleData';
const Attestation = 'Attestation';
const VOLAttestation = `${VolunteerCoordinator} ${Attestation}`;
const SPAttestation = `${Spiritual} ${Attestation}`;
const SWAttestation = `${SocialWorker} ${Attestation}`;
const NurseAttestation = `${Nurse} ${Attestation}`;
const DoctorAttestation = `${Doctor} ${Attestation}`;
const IDGMeetingMaster = 'IDG Meeting Master';
const IDGMNotes = `${IDGMeetingMaster} Notes`;
const TeamReviewAndAcc = `Team Review and Acceptance`;
const OtherNotes = 'Other Notes';

const orderComparitor = (a, b) => {
  if (a[1].order > b[1].order) return 1;
  if (a[1].order < b[1].order) return -1;
  return 0;
};

const noteMapper = orderTuple => {
  var _orderTuple$, _orderTuple$2;

  return [(_orderTuple$ = orderTuple[1]) === null || _orderTuple$ === void 0 ? void 0 : _orderTuple$.title, (_orderTuple$2 = orderTuple[1]) === null || _orderTuple$2 === void 0 ? void 0 : _orderTuple$2.notes];
};

export const parseIDGNotes = progressNotes => {
  const noteReducer = (seed, note) => {
    var _note$patientprogress, _note$patientprogress2;

    const progressNote = note === null || note === void 0 ? void 0 : note.patientprogressnoteentitydto[0];
    const isIDGMeetingMasterNote = note === null || note === void 0 ? void 0 : (_note$patientprogress = note.patientprogressnoteentitydto[0]) === null || _note$patientprogress === void 0 ? void 0 : _note$patientprogress.isidgmeetingmaster;
    const isAttestationNote = note === null || note === void 0 ? void 0 : (_note$patientprogress2 = note.patientprogressnoteentitydto[0]) === null || _note$patientprogress2 === void 0 ? void 0 : _note$patientprogress2.isidgattestation;
    const masterNote = isIDGMeetingMasterNote && !isAttestationNote;
    const roleGroupName = progressNote === null || progressNote === void 0 ? void 0 : progressNote.rolegroupname;
    if (!progressNote) return seed;

    if (masterNote) {
      var _seed$IDGMeetingMaste;

      if (!seed[IDGMeetingMaster]) seed[IDGMeetingMaster] = idgNotesHash[IDGMeetingMaster];
      ((_seed$IDGMeetingMaste = seed[IDGMeetingMaster]) === null || _seed$IDGMeetingMaste === void 0 ? void 0 : _seed$IDGMeetingMaste.notes) && seed[IDGMeetingMaster].notes.push(note);
    } else if (roleGroupName) {
      var _seed$roleGroupName;

      if (!seed[roleGroupName] && idgNotesHash[roleGroupName]) seed[roleGroupName] = idgNotesHash[roleGroupName];
      ((_seed$roleGroupName = seed[roleGroupName]) === null || _seed$roleGroupName === void 0 ? void 0 : _seed$roleGroupName.notes) && seed[roleGroupName].notes.push(note);
    } else {
      var _seed$OtherNotes;

      if (!seed[OtherNotes]) seed[OtherNotes] = idgNotesHash[OtherNotes];
      ((_seed$OtherNotes = seed[OtherNotes]) === null || _seed$OtherNotes === void 0 ? void 0 : _seed$OtherNotes.notes) && seed[OtherNotes].notes.push(note);
    }

    return seed;
  };

  const idgNotesHash = {
    [VolunteerCoordinator]: {
      order: 1,
      title: VOLAttestation,
      notes: []
    },
    [Spiritual]: {
      order: 2,
      title: SPAttestation,
      notes: []
    },
    [SocialWorker]: {
      order: 3,
      title: SWAttestation,
      notes: []
    },
    [Nurse]: {
      order: 4,
      title: NurseAttestation,
      notes: []
    },
    [Doctor]: {
      order: 5,
      title: DoctorAttestation,
      notes: []
    },
    [IDGMNotes]: {
      order: 6,
      title: IDGMNotes,
      notes: []
    },
    [TeamReviewAndAcc]: {
      order: 7,
      title: TeamReviewAndAcc,
      notes: []
    },
    [OtherNotes]: {
      order: 8,
      title: OtherNotes,
      notes: []
    }
  };
  const resp = Object.entries(progressNotes.reduce(noteReducer, {})).sort(orderComparitor).map(noteMapper);
  return resp;
};
export const getIDGContent = ({
  patientid,
  patientnumber,
  idgdata
}) => ({
  patientNumber: patientnumber,
  patientID: patientid,
  from: idgdata.fromdate,
  to: idgdata.todate,
  idgSourceKey: null,
  agency: null,
  idgReviewComplete: null,
  idgNarratives: null,
  idgMeetingID: idgdata.idgid,
  idgRoleAttestationDone: 0,
  allIdgQuestionnaires: null
});

const formatCarePlans = carePlans => ({
  notes: carePlans.reduce((seed, value) => {
    if (value.freqnotes !== '[null]') {
      try {
        seed[value.id] = JSON.parse(value.freqnotes);
      } catch {
        console.error('error parsing frequency notes');
      }
    }

    return seed;
  }, {}),
  frequencies: carePlans.map(cp => ({
    roleGroupId: cp.role_group_id,
    daysOfWeek: cp.daysofweek,
    effectiveDate: cp.effective_date,
    endDate: cp.end_date,
    frequencyFirstPartial: cp.frequency_first_partial,
    frequencyText: cp.frequency_text,
    patientNumber: cp.patient_number,
    roleName: cp.role_name,
    siteId: cp.site_id,
    userComments: cp.user_comments,
    frequency: cp.frequency,
    discipline: cp.discipline,
    id: cp.id // ...cp,

  }))
});

const formatMeasures = measures => measures.reduce((seed, measure) => {
  if (seed[measure.categoryshortname]) {
    if (seed[measure.categoryshortname][measure.measuretypeshortname]) {
      seed[measure.categoryshortname][measure.measuretypeshortname].push(measure);
    } else {
      seed[measure.categoryshortname][measure.measuretypeshortname] = [measure];
    }
  } else {
    seed[measure.categoryshortname] = {};
    seed[measure.categoryshortname][measure.measuretypeshortname] = [measure];
  }

  return seed;
}, {});

const formatMeds = meds => meds.map(med => _objectSpread(_objectSpread({}, med), {}, {
  mednotes: JSON.parse(med.mednotes),
  medorders: JSON.parse(med.medorders)
}));

const formatForms = forms => forms.map(form => {
  const newForm = _objectSpread(_objectSpread({}, form), {}, {
    createdatetime: form.createdatetime.split('T').join(' '),
    createdatetimeshifted: form.createdatetimeshifted.split('T').join(' '),
    isidg: form.isidg ? 't' : 'f',
    isipu: form.isipu ? 'true' : 'false',
    isresolved: form.isresolved ? 'true' : 'false',
    isformsubmissionrequired: form.isformsubmissionrequired ? 'true' : 'false',
    formisnonrequiredallowed: form.formisnonrequiredallowed ? 'true' : 'false',
    requirednotenforced: form.requirednotenforced ? 'true' : 'false',
    formid: `${form.form_id}`,
    createpersonid: `${form.createpersonid}`,
    patientid: `${form.patientid}`,
    id: `${form.id}`,
    siteid: `${form.siteid}`,
    reverserank: `${form.reverserank}`,
    formsubmission: form.formsubmission === null ? '' : form.formsubmission,
    qtype: form.qtype === null ? '' : form.qtype,
    label: form.label === null ? '' : form.label,
    responsedata: form.responsedata === null ? '' : form.responsedata,
    standardurl: form.standardurl === null ? '' : form.standardurl,
    patientvisit_id: form.patientvisit_id === null ? '' : form.patientvisit_id,
    idgdata: form.idgdata ? form.idgdata : null,
    originalsourcekey: form.originalsourcekey === null ? '' : form.originalsourcekey,
    originalvisitdatetime: form.originalvisitdatetime === null ? '' : form.originalvisitdatetime,
    originalvisitdatetimeshifted: form.originalvisitdatetimeshifted === null ? '' : form.originalvisitdatetimeshifted
  });

  delete newForm.form_id;
  return newForm;
});

const formatProblems = problems => problems.map(prob => _objectSpread(_objectSpread({}, prob), {}, {
  probnotes: prob.probnotes && JSON.parse(prob.probnotes) || [],
  probtasks: prob.probtasks && JSON.parse(prob.probtasks) || []
}));

const formatNotes = notes => notes.map(note => _objectSpread(_objectSpread({}, note), {}, {
  noteddatetime: note.notedatetime
}));

const formatMap = new Map([['frequencydto', formatCarePlans], ['measuresdto', formatMeasures], ['medsdto', formatMeds], ['formsdto', formatForms], ['problemsdto', formatProblems], ['notesdto', formatNotes]]);
export const formatDocumentData = IDGData => {
  const docData = _objectSpread({}, IDGData.idgdata);

  const keys = Object.keys(docData);
  keys.forEach(k => {
    try {
      if (k === 'fromdate' || k === 'todate') {
        return;
      }

      docData[k] = docData[k] && JSON.parse(docData[k]) || [];

      if (formatMap.has(k)) {
        const formatter = formatMap.get(k);

        if (formatter) {
          docData[k] = formatter(docData[k]);
        }
      }
    } catch {
      console.error(`Error parsing idg data: key '${k}, value ${docData[k]}`);
    }
  }); // Overide rolegroup name for attestations to display RG attestation is for, not person making it.

  if (docData.patientProgressNoteEntityDTOS.length && docData.notesdto.length) {
    docData.patientProgressNoteEntityDTOS.forEach(pne => {
      if (pne.isidgattestation !== 'true') return;
      const note = docData.notesdto.find(pn => pn.id.toString() === pne.patientprogressnoteid);

      if (note) {
        note.rolegroupname = pne.rolegroupname;
      }
    });
  }

  return docData;
};